import React from "react";
import { Typography, Grid, Box, FormControl, OutlinedInput, Card } from "@mui/material"
import SelectImage from "../../../static/images/salesOrder/Done-rafiki.svg"
import theme, {
    textClasses,
    cardClasses,
 
} from "../../../static/styles/theme";

 
const ExternalFormCompletion = () => {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      height="100vh"
      sx={{ backgroundColor: theme.themeOrange, p: 2 }}
    >
      <Card
        sx={{
          p: 3,
          ...cardClasses.basic,
          width: { xs: "90%", sm: "70%", md: "64vw" }, // ✅ responsive width
          minHeight: "20vh",
          borderRadius: "12px",
        }}
        className="mui-custom-card"
      >
        {/* Image */}
        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
          <Box
            component="img"
            src={SelectImage}
            alt="Success"
            sx={{
              width: { xs: "80%", sm: "450px" }, // responsive scaling
              height: "auto",
              maxHeight: { xs: "200px", sm: "300px" },
              objectFit: "contain",
            }}
          />
        </Grid>

        {/* Text */}
        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
          <Typography
            sx={{
              ...textClasses.t16n,
              textAlign: "center",
              mt: 1,
              fontWeight: "600",
              fontSize: { xs: "14px", sm: "16px" }, //  smaller font on mobile
            }}
          >
            Sales Order Form has been Successfully Submitted.
          </Typography>
        </Grid>
      </Card>
    </Grid>
  );
};

export default ExternalFormCompletion;
